import { FunctionComponent, useContext, useState } from "react";
import styles from "./DashboardSideBar.module.css";
import images from "../../../assets/images/index";
import { useLocation, useNavigate } from "react-router-dom";
import { globalContext } from "../../../Provider/AppProvider";
import { roles } from "../../../helper";
import AddIcon from "../../../assets/images/AddIcon.svg";
import organalytics from "../../../assets/images/organalytics.svg";
import v2pricing from "../../../assets/images/v2pricing.svg";
import salesrep from "../../../assets/images/salesrep.svg";
import affiliate from "../../../assets/images/affiliate.svg";
import eventupdate from "../../../assets/images/eventupdate.svg";
import teamupdate from "../../../assets/images/teamsupdate.svg";
// import teamsupdate from "../../../assets/images/teamupdate.svg";
import venueupdate from "../../../assets/images/venue.svg";
import ticketmaster from "../../../assets/images/ticketmaster.svg";
import trends from "../../../assets/images/trends.svg";
import goals from "../../../assets/images/goals.svg";
import dashboard from "../../../assets/images/Dashboard.svg";
import users from "../../../assets/images/Users.svg";
import tickets from "../../../assets/images/tickets.svg";
import { isPageAccessControlledRole } from "../../../constants/pageAccess";

interface SidebarProps {
  path: string;
  onclick: () => void;
  label: string;
  icon: string;
  alt: string;
  badge?: string;
}

interface Dashboardprops {
  showSidebar?: boolean;
}

const DashboardSideBar: FunctionComponent<Dashboardprops> = ({
  showSidebar,
}) => {
  const [sidebarMode, setSidebarMode] = useState<"sell" | "buy">("sell");
  const {
    sidebarQuickAsystLogo,
    dahsboardIcon,
    sidebarTicketIcon,
    sidebarUserIcon,
    AffiliateIcon,
    QuickAsystIcon,
    errordashboard,
    manageAccountIcon,
    settings
  } = images;
  const navigate = useNavigate();
  const location = useLocation();
  const {globalState} = useContext<any>(globalContext)
  
  const routes: SidebarProps[] = [];
  
  if (globalState.profile.userRole === roles.ADMIN) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dashboard,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
      },
      {
        path: "setting",
        onclick: () => navigate("/setting"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
      {
        path: "auditLogs",
        onclick: () => navigate("/auditLogs"),
        label: "Audit Logs",
        icon: errordashboard,
        alt: "activityLogsIcon",
      },
      {
        path: "role-page-access",
        onclick: () => navigate("/role-page-access"),
        label: "Role Access",
        icon: manageAccountIcon,
        alt: "roleAccessIcon",
      }
    )
  } else if (globalState.profile.userRole === roles.AFFILIATER_ADMIN) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dahsboardIcon,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
      },
      {
        path: "setting",
        onclick: () => navigate("/setting"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
    )
  } else if (globalState.profile.userRole === "logitix_user") {
    routes.push(
      {
        path: "tickets",
        onclick: () => navigate("/tickets"),
        label: "Tickets",
        icon: sidebarTicketIcon,
        alt: "TicketsIcon",
      },
      {
        path: "settings",
        onclick: () => navigate("/settings"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
      {
        path: "logs",
        onclick: () => navigate("/logs"),
        label: "Logs",
        icon: errordashboard,
        alt: "errorIcon",
      },
    )
  } else if (globalState.profile.userRole === roles.SUPER_USER) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dahsboardIcon,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: sidebarTicketIcon,
        alt: "ManageTicketsIcon",
      },
      {
        path: "profile",
        onclick: () => navigate("/profile"),
        label: "Profile",
        icon: sidebarUserIcon,
        alt: "ProfileIcon",
      },
    );
  } else if (globalState.profile.userRole === "marketing_user" || globalState.profile.userRole === roles.SUB_ADMIN) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dashboard,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
      },
      {
        path: "setting",
        onclick: () => navigate("/setting"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
      {
        path: "auditLogs",
        onclick: () => navigate("/auditLogs"),
        label: "Audit Logs",
        icon: errordashboard,
        alt: "activityLogsIcon",
      },
    );
  }

  const pageKeyBySidebarPath: Record<string, string> = {
    dashboard: "dashboard",
    trends: "trends",
    goals: "goals",
    managetickets: "managetickets",
    addticket: "addticket",
    analytics: "analytics",
    salesrep: "salesrep",
    "event-update": "event-update",
    teamupdate: "teamupdate",
    venueupdate: "venueupdate",
    ticketmaster: "ticketmaster",
    setting: "setting",
    "new-list": "new-list",
    tickets: "tickets",
    users: "users",
    affiliate: "affiliate",
    logs: "logs",
    auditLogs: "logs",
    profile: "profile",
  };

  const role = globalState.profile.userRole;
  const allowedPageKeys: string[] = globalState?.profile?.allowedPageKeys || [];

  const visibleRoutes = routes.filter((route) => {
    if (!isPageAccessControlledRole(role)) {
      return true;
    }
    const pageKey = pageKeyBySidebarPath[route.path];
    if (!pageKey) {
      return false;
    }
    return allowedPageKeys.includes(pageKey);
  });

  const pathSlug = location.pathname.slice(1);
  const isRouteActive = (routePath: string) => {
    if (routePath === "managetickets" && (pathSlug === "managetickets" || pathSlug === "new-list")) {
      return true;
    }
    return pathSlug === routePath || pathSlug.includes(routePath);
  };

  return (
    <div
      className={`${styles.dashboardSideBar} ${
        showSidebar ? styles.expanded : styles.collapsed
      }`}
    >
      <div className={`${styles.logo} ${
        showSidebar ? styles.expandedlogo : styles.collapsedlogo
      }`}>
        <img
          className={
            showSidebar? styles.QuickAsystIcon  : styles.QuickAsystIconhide
          }
          alt="sidebarLogo"
          src={showSidebar? sidebarQuickAsystLogo: QuickAsystIcon}
          onClick={() => {
            const userRole = globalState.profile.userRole;
            if (isPageAccessControlledRole(userRole)) {
              const hasDashboardAccess = allowedPageKeys.includes("dashboard");
              navigate(hasDashboardAccess ? "/dashboard" : "/no-access");
              return;
            }
            if (userRole === roles.AFFILIATER_ADMIN) {
              navigate("/dashboard");
              return;
            }
            if (userRole===roles.ADMIN) {
              navigate("/dashboard");
              return;
            }
            if (userRole === roles.SUPER_USER) {
              navigate("/dashboard");
              return;
            }
            navigate("/managetickets");
          }}
          data-testid="sidebarLogo"
        />
      </div>
                        
    {showSidebar && globalState.profile.userRole !== roles.SUPER_USER && globalState.profile.userRole !== roles.AFFILIATER_ADMIN && (
        <div className={styles.toggleContainer}>
          <button 
            className={`${styles.toggleBtn} ${sidebarMode === 'buy' ? styles.buyactive : ''}`}
            onClick={() => setSidebarMode('buy')}
          >
            <span className={styles.buyIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-shopping-cart w-3 h-3" aria-hidden="true" x-file-name="App" x-line-number="971" x-component="ShoppingCart" x-id="App_971" x-dynamic="false"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>
            </span> Buy
          </button>
          <button 
            className={`${styles.toggleBtn} ${sidebarMode === 'sell' ? styles.sellactive : ''}`}
            onClick={() => setSidebarMode('sell')}
          >
            <span className={styles.sellIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-3 h-3" aria-hidden="true" x-file-name="App" x-line-number="984" x-component="Tag" x-id="App_984" x-dynamic="false"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
            </span> Sell
          </button>
        </div>
      )}
      
      {showSidebar ? (
        <div className={styles.menuContainer}>
          {/* mapping the sidebar routes  */}
          {visibleRoutes.map((route: SidebarProps, index: number) => (
            <div
              className={
                isRouteActive(route.path)
                  ? styles.dashboardActive
                  : styles.dashboardInactive
              }
              onClick={route.onclick}
              key={`sidebar-${index}`}
            >
              <img
                className={styles.roundedOutlineDashboard}
                alt={route.alt}
                src={route.icon}
              />
              <div className={styles.dashboard1}>
                {route.label}
                {route.badge && <span className={styles.badge}>{route.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.menuContainer}>
          {/* mapping the sidebar routes  */}
          {visibleRoutes.map((route: SidebarProps, index: number) => (
            <div
              className={
                isRouteActive(route.path)
                  ? styles.dashboardActive
                  : styles.dashboardInactive
              }
              onClick={route.onclick}
              key={`sidebar-${index}`}
            >
              <img
                className={styles.roundedOutlineDashboard}
                alt={route.alt}
                src={route.icon}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardSideBar;